import React, { useState } from 'react';
import PropType from 'prop-types';
import ModalMarketingForm from 'components/ModalMarketingForm';
import Button from 'components/Button';
import ContentfulRichText from 'components/RichText/ContentfulRichText';
import TextLink from 'components/TextLink';
import Styles from 'components/Styles';
import getColor from 'utils/getColor';
import WistiaVideo from 'components/WistiaVideo';
const CallToAction = props => {
  const {
    buttonClass,
    buttonLabel,
    color,
    id,
    isPlaying,
    url,
    modalForm,
    useModalForm,
    textLabel,
    type,
    setIsPlaying,
    shadow,
    styles,
    wistiaVideo,
  } = props;
  const [isModalOpen, toggleIsModalOpen] = useState(false);
  const WISTIA = 'https://servicetitan-1.wistia.com';
  const popover = url?.includes(WISTIA);

  return (
    <>
      {popover ? (
        <WistiaVideo
          url={url}
          label={
            textLabel ? <ContentfulRichText richText={textLabel} /> : buttonLabel || 'Play Video'
          }
          labelProps={{
            theme: getColor(textLabel?.color),
            labelSize: textLabel?.paragraphSize,
          }}
        />
      ) : wistiaVideo ? (
        <WistiaVideo {...wistiaVideo} cta={props} />
      ) : textLabel ? (
        <Styles {...styles}>
          <TextLink
            to={url}
            onClick={useModalForm ? () => toggleIsModalOpen(true) : null}
            data-testid="call-to-action--text-link"
          >
            <ContentfulRichText richText={textLabel} />
          </TextLink>
        </Styles>
      ) : (
        <Button
          className={buttonClass}
          type={type || color}
          shadow={shadow}
          styles={styles}
          to={url}
          onClick={
            setIsPlaying
              ? () => setIsPlaying(!isPlaying)
              : useModalForm
              ? () => toggleIsModalOpen(true)
              : null
          }
          id={id}
        >
          {buttonLabel}
        </Button>
      )}
      {useModalForm && (
        <ModalMarketingForm
          isModalOpen={isModalOpen}
          onModalCancel={() => toggleIsModalOpen(false)}
          marketingForm={modalForm}
          onFormSuccess={() => toggleIsModalOpen(false)}
        />
      )}
    </>
  );
};

export default CallToAction;

CallToAction.defaultProp = {
  shadow: false,
};

CallToAction.propType = {
  buttonClass: PropType.string,
  buttonlabel: PropType.string,
  color: PropType.string,
  url: PropType.string,
  carryUtmParameters: PropType.bool,
  useModalForm: PropType.bool,
  type: PropType.string,
  shadow: PropType.bool,
};
